<template>
    <!-- fluid grid-list-md -->
    <v-container>
        <v-row>
            <v-col>
                <div class="text-h5">Leveranser</div>

                <v-row align="center" class="elevation-1 white mx-1">
                    <v-col cols="auto">
                        <v-btn color="success" to="/delivery/details/0">
                            <v-icon left>mdi-plus-circle-outline</v-icon>
                            Ny leveranse
                        </v-btn>
                    </v-col>

                    <!-- <v-divider vertical class="mx-2 py-2"></v-divider> -->

                    <v-col cols="auto">
                        <v-btn-toggle v-model="showAll" mandatory dark>
                            <v-btn label="mine leveranser" :value="false" small color="info">mine</v-btn>
                            <v-btn label="alle leveranser" :value="true" small color="info">alle</v-btn>
                        </v-btn-toggle>
                    </v-col>

                    <!-- <v-divider vertical class="mx-2 py-2"></v-divider> -->

                    <v-col cols="12" sm="auto">
                        <v-text-field hide-details v-model="search" clearable label="søk" hint="kan bruke søkoprator: emne:, sone:, eier:, leverandør:" append-icon="mdi-magnify"></v-text-field>
                    </v-col>

                    <!-- <v-divider vertical class="mx-2 py-2"></v-divider> -->
                    <v-col cols="12" sm="auto">
                        <v-menu v-model="searchFromShow" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" v-model="searchFrom" ref="searchFrom" hide-details readonly label="Fra: YYYY-MM-DD" clearable append-icon="mdi-clock-outline" :rules="[v => !v || moment(v).isValid() || 'Feil format']"></v-text-field>
                            </template>
                            <v-date-picker v-model="searchFrom" @input="searchFromShow = false" first-day-of-week="1" :title-date-format="(x) => moment(x).format('ddd, D MMM')" :weekday-format="(x) => moment(x).format('dd')" :header-date-format="(x) => moment(x).format('MMM')" :month-format="(x) => moment(x).format('MMM')"></v-date-picker>
                        </v-menu>
                    </v-col>

                    <!-- <v-divider vertical class="mx-2 py-2"></v-divider> -->
                    <v-col cols="12" sm="auto">
                        <v-menu v-model="searchToShow" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y max-width="290">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-on="on" v-model="searchTo" ref="searchTo" hide-details readonly label="Til: YYYY-MM-DD" clearable append-icon="mdi-clock-outline" :rules="[v => !v || moment(v).isValid() || 'Feil format']"></v-text-field>
                            </template>
                            <v-date-picker v-model="searchTo" @input="searchToShow = false" first-day-of-week="1" :title-date-format="(x) => moment(x).format('ddd, D MMM')" :weekday-format="(x) => moment(x).format('dd')" :header-date-format="(x) => moment(x).format('MMM')" :month-format="(x) => moment(x).format('MMM')"></v-date-picker>
                        </v-menu>
                    </v-col>

                </v-row>

            </v-col>
        </v-row>
        <br>

        <v-row>
            <v-col cols="12" lg="8">
                <v-data-table :headers="headers" :items="filteredDeliveries" :loading="deliveriesLoading" class="elevation-1" hide-default-footer :items-per-page="-1" :mobile-breakpoint=0>
                    <template v-slot:item={item}>
                        <tr @click="$router.push(`/delivery/details/${item.id}`)" :class="item.inAccessCode.claims > 0 ? (item.outAccessCode.claims > 0 ? 'green lighten-4' : 'orange lighten-4'): ''" style="cursor:pointer">
                            <td>{{item.name}}</td>
                            <td style="white-space: nowrap">{{item.zone.name}}</td>

                            <td>
                                <span>{{item.resources.length == 0 ? '0' : item.resources.map(r => r.usage).reduce((sum, val) => { return sum + val; })}} totalt</span>
                            </td>

                            <td style="white-space: nowrap">{{moment.unix(item.start).format('DD.MM.YY @ HH:mm:ss')}}</td>
                            <td>
                                <span class="body-1 text-truncate">
                                    {{item.createdBy ? item.createdBy.name : '?'}}
                                    <br v-if="item.createdBy.company">
                                    <span style="font-size: 11px">
                                        {{item.createdBy.company ? item.createdBy.company.name : ''}}
                                    </span>
                                </span>
                            </td>
                            <td>
                                {{item.supplier? item.supplier.name: '-'}}
                            </td>
                            <td>
                                <v-btn icon @click.stop="requestDeleteDelivery(item)" class="ma-0">
                                    <v-icon color="info">mdi-delete</v-icon>
                                </v-btn>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
            <v-col cols="12" lg="4">
                <h2>Riggplan</h2>
                <!-- <span v-if="!siteplan.loading && !siteplan_api" class="ma-2">
                    <v-icon>mdi-alert</v-icon> Ingen riggplan lasted opp
                </span>
                <v-progress-linear v-if="siteplan.loading" indeterminate color="primary"></v-progress-linear>
                <v-img top contain :src="siteplan_api" @click="siteplan.showSiteplan = true" style="cursor:pointer;" class="ma-1"></v-img> -->

                <div style="cursor: pointer;">
                    <v-carousel>
                        <v-carousel-item v-for="siteplan in siteplans" :key="siteplan">
                            <!-- <v-btn absolute class="ma-2" light fab small color="primary" @click.stop="() => {content = siteplan; contentShow = true;}">
                                <v-icon>mdi-fullscreen</v-icon>
                            </v-btn> -->
                            <v-progress-linear v-if="!siteplan.src" indeterminate></v-progress-linear>
                            <v-img v-if="/^data:image\/.*/.test(siteplan.src) && !!siteplan.src" :src="siteplan.src" contain height="100%" width="100%" @click.stop="() => {content = siteplan; contentShow = true;}"></v-img>
                            <!-- <div v-if="/^data:image\/.*/.test(siteplan.src) && !siteplan.src" style="background: red; height:100%; width:100%;">
                                <v-progress-circular indeterminate></v-progress-circular>
                            </div> -->

                            <!-- <object v-if="/^data:application\/pdf.*/.test(siteplan.src) && !!siteplan.src" :data="siteplan.url" type="application/pdf" style="height: -webkit-fill-available; width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;"> -->
                            <!-- <div v-if="/^data:application\/pdf.*/.test(siteplan.src) && !!siteplan.src">
                            <iframe :src="`https://docs.google.com/viewer?url=${siteplan.url}&embedded=true`" frameborder="0" marginheight="0" marginwidth="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" style="height: -webkit-fill-available; width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;"></iframe>
                        </div> -->

                            <iframe v-if="/^data:application\/pdf.*/.test(siteplan.src) && !!siteplan.src" :src="`${siteplan.url}#view=fit&toolbar=0`" allowfullscreen="true" height="100%" width="100%" style="height: -webkit-fill-available; width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;"></iframe>
                            <!-- <div v-if="/^data:application\/pdf.*/.test(siteplan.src) && (!siteplan.src || siteplan.src.length == 0)" style="background: red">
                                <v-progress-circular indeterminate></v-progress-circular>
                            </div> -->

                        </v-carousel-item>
                    </v-carousel>
                </div>

            </v-col>
        </v-row>

        <!-- <v-dialog v-model="contentShow" @keyup.esc="() => { contentShow = false; }">
            <v-card>
                <v-card-title class="text-subtitle-2">
                    <div class="d-flex flex-row align-center" style="width: 100%">
                        <div class="mr-2">{{content.name}}</div>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" fab x-small class="text-subtitle-2" @click="() => { contentShow = false; }">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="ma-0 pa-0">
                    <div class="d-flex align-stretch pa-1" style="height: 80vmin; width: -webkit-fill-available;" v-if="content && content.name && (content.name.toLowerCase().includes('.jpg') || content.name.toLowerCase().includes('.png'))">
                        <v-img contain :src="content.src"></v-img>
                    </div>
                    <div class="d-flex align-stretch pa-1" style="background: grey; height: 80vmin; width: -webkit-fill-available;" v-if="content && content.name && (content.name.toLowerCase().includes('.pdf'))">
                        <iframe :src="`${content.url}#view=fit`" allowfullscreen="false" height="100%" width="100%" style="width: -webkit-fill-available; padding: 0px; margin: 0px; border: none;"></iframe>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog> -->

        <v-dialog v-model="contentShow" @keydown.esc="() => {contentShow = false; contentFullscreen = false;}">
            <div v-if="content && content.name" style="max-height: 90vmin; background: white; position: relative;">
                <div style="position: absolute; background: rgba(255,255,255,0.65); z-index: 10;" class="ma-2 pa-2 text-h6">{{/.*\/.*\/(.*)/.exec(content.name)[1]}}</div>
                <div style="position: absolute; top: 10px; right: 10px; z-index: 10; display: flex; flex-direcion: row;">
                    <v-btn fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => {contentFullscreen = !contentFullscreen;}">
                        <v-icon v-if="contentFullscreen">mdi-fullscreen-exit</v-icon>
                        <v-icon v-else>mdi-fullscreen</v-icon>
                    </v-btn>
                    <div class="mx-1"></div>
                    <v-btn fab small color="rgba(255,255,255,0.65)" style="position: sticky;" @click="() => { contentShow = false; contentFullscreen = false;}">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-img v-if="!contentFullscreen" :src="content.src" class="ma-auto" max-height="90vmin" max-width="90vmin" :contain="!contentFullscreen"></v-img>
                <v-img v-else :src="content.src" class="ma-auto"></v-img>

            </div>
        </v-dialog>

        <v-dialog v-model="deliveryDelete.show" max-width="500">
            <v-card>
                <v-card-title class="headline grey lighten-2">
                    Slett leveranse: {{deliveryDelete.name}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="deliveryDelete.show = false; deliveryDelete.id = 0;">avbryt</v-btn>
                    <v-btn @click="executeDeleteDelivery(deliveryDelete.id)" color="primary">ok</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
// import axios from "axios";
import * as utilities from "../utilities/equalizer";
import moment from "moment";
// import colors from "vuetify/es5/util/colors";

export default {
    data() {
        return {
            model: "",
            files: {},
            counter: 5,
            search: "",
            searchFromShow: false,
            searchFromDebounceTimeoutTimeout: null,
            searchFrom: moment()
                .subtract(1, "week")
                .format("YYYY-MM-DD"),
            searchToShow: false,
            searchToDebounce: null,
            searchTo: "",
            headers: [
                { text: "Emne", sortable: false },
                { text: "Sone", sortable: false },
                { text: "Ressurser", sortable: false },
                { text: "Leveringstid", sortable: false },
                { text: "Eier", sortable: false },
                // { text: "Endret av", sortable: false },
                { text: "Leverandør", sortable: false },
                { text: "Handlinger", sortable: false }
            ],
            deliveries: [],
            deliveriesLoading: false,
            showAll: true,
            deliveryDelete: {
                id: 0,
                name: "",
                show: false
            },
            popup: {
                x: 0,
                y: 0,
                show: false,
                title: "",
                items: [{ title: "slett", icon: "delete" }]
            },
            contentFullscreen: false,
            contentShow: false,
            content: {
                name: undefined
            },
        };
    },
    computed: {
        filteredDeliveries() {
            // if (this.search && this.search.length < 2) {
            //     return this.deliveries;
            // }

            let _property;
            let _search = this.search ? this.search.repeat(1) : "";

            let userSearch = /\s*eier:\s*(.*)/gi;
            let userSearchResult = userSearch.exec(this.search);
            if (userSearchResult) {
                _property = "createdBy.name";
                _search = userSearchResult[1];
            }

            let supplierSearch = /\s*leverandør:\s*(.*)/gi;
            let supplierSearchResult = supplierSearch.exec(this.search);
            if (supplierSearchResult) {
                _property = "supplier.name";
                _search = supplierSearchResult[1];
            }

            let titleSearch = /\s*emne:\s*(.*)/gi;
            let titleSearchResult = titleSearch.exec(this.search);
            if (titleSearchResult) {
                _property = "name";
                _search = titleSearchResult[1];
            }

            let zoneSearch = /\s*sone:\s*(.*)/gi;
            let zoneSearchResult = zoneSearch.exec(this.search);
            if (zoneSearchResult) {
                _property = "zone.name";
                _search = zoneSearchResult[1];
            }

            let _deliveries = this.deliveries;

            if (!this.showAll) {
                _deliveries = _deliveries.filter(d => {
                    return d.createdBy_id == this.$store.getters.userId;
                });
            }

            if (_property) {
                _deliveries = _deliveries.filter(d => {
                    let value = utilities.getValue(d, _property);
                    if (!value) return false;

                    return utilities
                        .getValue(d, _property)
                        .toLowerCase()
                        .includes(_search.toLowerCase());
                });
            } else {
                _deliveries = _deliveries.filter(d => {
                    let ok = false;
                    // if (
                    //     !this.showAll &&
                    //     d.createdBy_id == this.$store.getters.userId
                    // ) {
                    //     ok = true;
                    // }

                    if (d.name.toLowerCase().includes(_search.toLowerCase())) {
                        ok = true;
                    }
                    if (!!d.createdBy && d.createdBy.name.toLowerCase().includes(_search.toLowerCase())) {
                        ok = true;
                    }
                    if (!!d.supplier && d.supplier.name.toLowerCase().includes(_search.toLowerCase())) {
                        ok = true;
                    }

                    return ok;
                });
            }

            if (moment(this.searchFrom).isValid()) {
                _deliveries = _deliveries.filter(d => {
                    return (
                        d.start >=
                        moment(this.searchFrom)
                            .startOf("day")
                            .unix()
                    );
                });
            }
            if (moment(this.searchTo).isValid()) {
                _deliveries = _deliveries.filter(d => {
                    return (
                        d.start <=
                        moment(this.searchTo)
                            .endOf("day")
                            .unix()
                    );
                });
            }

            return _deliveries;
        },
        siteplans() {
            return this.$store.getters.filesByType("siteplans");
        }
    },
    methods: {
        resSummary: function(delivery) {
            let summarizedResources = [];
            delivery.resources.forEach(r => {
                let sresource = summarizedResources.find(sr => sr.id === r.id);
                if (!sresource) {
                    summarizedResources.push({
                        id: r.id,
                        name: r.name,
                        usage: r.usage
                    });
                } else {
                    sresource.usage += r.usage;
                }
            });

            return summarizedResources
                .map(r => {
                    return `${r.name} (${r.usage})`;
                })
                .join(", ");
        },
        startCountdown: function() {
            var timer = setInterval(() => {
                // console.log(this.counter--);
                if (this.counter == 0) {
                    this.counter = 5;
                    clearInterval(timer);
                    this.files = {};
                }
            }, 1000);
        },
        executeDeleteDelivery: function(id) {
            this.axios
                .delete(`/delivery/${id}`)
                .then(response => {
                    if (response.data.success) {
                        // snackbar

                        this.$store.commit("snackbar", {
                            text: "Leveranse slettet.",
                            color: "success",
                            show: true
                        });

                        let index = this.deliveries.findIndex(d => d.id == id);
                        this.deliveries.splice(index, 1);
                    } else {
                        // snackbar

                        this.$store.commit("snackbar", {
                            text: "Leveranse ikke slettet.",
                            color: "error",
                            show: true
                        });
                    }

                    this.deliveryDelete.show = false;
                    this.deliveryDelete.id = 0;
                    this.deliveryDelete.name = "";
                })
                .catch(() => {
                    // console.log(error);
                });
        },
        requestDeleteDelivery: function(delivery) {
            if (delivery) {
                this.deliveryDelete.id = delivery.id;
                this.deliveryDelete.name = delivery.name;
                this.deliveryDelete.show = true;
            }
        },
        showPopup(e, delivery) {
            e.preventDefault();
            this.popup.show = false;
            this.popup.x = e.clientX;
            this.popup.y = e.clientY;
            this.popup.title = delivery.name;
            this.popup.item = delivery;
            this.$nextTick(() => {
                this.popup.show = true;
            });
        },
        fetchDeliveries(from, to) {
            // console.log(from);
            // console.log(to);

            if ((!!from && !moment(from).isValid()) || (!!to && !moment(to).isValid())) {
                // console.log("dates not valid");
                return;
            }

            this.deliveriesLoading = true;
            let start = !!from && moment(from).isValid() ? moment(from).startOf("day") : null;
            let end = !!to && moment(to).isValid() ? moment(to).endOf("day") : null;

            let url = "/delivery";

            if (start && end) {
                url = `/delivery?start=${start.unix()}&end=${end.unix()}`;
            } else if (start && !end) {
                url = `/delivery?start=${start.unix()}`;
            } else if (!start && end) {
                url = `/delivery?end=${end.unix()}`;
            } else if (!start && !end) {
                url = `/delivery`;
            }

            this.axios
                .get(url, {
                    params: {
                        // includes: "createdBy.company"
                    }
                })
                .then(response => {
                    if (response.data.success) {
                        let _deliveries = response.data.data;
                        this.deliveries = _deliveries.sort((a, b) => {
                            return b.start - a.start;
                        });
                    }
                })
                .catch(() => {
                    // console.log(err);
                })
                .finally(() => {
                    this.deliveriesLoading = false;
                    if (this.deliveries && this.deliveries.length == 100) {
                        this.$store.commit("snackbar", {
                            text: "Søk begrenset til 100 leveranser.",
                            color: "error",
                            show: true
                        });
                    } else if (this.deliveries && this.deliveries.length >= 0) {
                        this.$store.commit("snackbar", {
                            text: `Hentet ${this.deliveries.length} leveranser`,
                            color: "success",
                            show: true
                        });
                    }
                });
        },
        async listSiteplans() {
            let files = await this.$store.dispatch("listFiles","siteplans");
            files.forEach(async (file) => {
                await this.$store.dispatch("addFile", file);
                if(!this.$store.getters.file(file.name).src){
                    let {binary, buffer, src, blob, url} = await this.$store.dispatch("downloadFile", file.name);

                    this.$set(file, "binary", binary);
                    this.$set(file, "buffer", buffer);
                    this.$set(file, "src", src);
                    this.$set(file, "blob", blob);
                    this.$set(file, "url", url);
                    await this.$store.dispatch("addFile", file);
                }
            });
        }
    },
    watch: {
        searchFrom() {
            // let now = moment();
            let debounceTime = 750;

            let searchFromFunction = function() {
                this.searchFromDebounceTimeout = null;
                this.fetchDeliveries(this.searchFrom, this.searchTo);
            };

            if (!this.searchFromDebounceTimeout) {
                this.searchFromDebounceTimeout = setTimeout(searchFromFunction.bind(this), debounceTime);
            } else {
                clearTimeout(this.searchFromDebounceTimeout);
                this.searchFromDebounceTimeout = setTimeout(searchFromFunction.bind(this), debounceTime);
            }
        },
        searchTo() {
            // let now = moment();
            let debounceTime = 750;

            if (!this.searchToDebounce) {
                this.searchToDebounce = setTimeout(() => {
                    this.searchToDebounce = null;
                    this.fetchDeliveries(this.searchFrom, this.searchTo);
                }, debounceTime);
            } else {
                clearTimeout(this.searchToDebounce);
                this.searchToDebounce = setTimeout(() => {
                    this.searchToDebounce = null;
                    this.fetchDeliveries(this.searchFrom, this.searchTo);
                }, debounceTime);
            }
        }
    },
    async mounted() {
        this.fetchDeliveries(this.searchFrom, this.searchTo);

        this.listSiteplans();
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
};
</script>

<style lang="scss" scoped>
.dropbox {
    outline: 2px dashed grey;
    outline-offset: -10px;
    background: lightcyan;
    color: dimgray;
    padding: 10px 10px;
    min-height: 200px;
    position: relative;
    cursor: pointer;
}
.dropbox:hover {
    background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
    font-size: 1.2em;
    text-align: center;
    padding: 50px 0;
}
.input-file {
    opacity: 0; /* invisible but it's there! */
    width: 100%;
    height: 200px;
    position: absolute;
    cursor: pointer;
}
</style>


